function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 256 384",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M128,0c70.645,0 128,57.355 128,128c0,70.645 -128,256 -128,256c0,0 -128,-185.355 -128,-256c0,-70.645 57.355,-128 128,-128Zm0,60c33.115,0 60,26.885 60,60c0,33.115 -26.885,60 -60,60c-33.115,0 -60,-26.885 -60,-60c0,-33.115 26.885,-60 60,-60Z",
    style: {
      fill: "#d62727"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 120,
    r: 32,
    style: {
      fill: "#272727"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin);
export default __webpack_public_path__ + "static/media/MapPin.685d0fc6b02dac8069391057a580d778.svg";
export { ForwardRef as ReactComponent };